import { render, staticRenderFns } from "./PersonalDataTab.vue?vue&type=template&id=90722054"
import script from "./PersonalDataTab.vue?vue&type=script&lang=ts"
export * from "./PersonalDataTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports